export default __webpack_public_path__ + "static/media/no-avatar.18684d82.svg";